import React from "react";
import ReactDOM from "react-dom";
import Results from './results';

class App extends React.Component {
  render() {
    const searchQuery = location.search.substring(1);
    let kidsQuizResults = '';

    if (
      searchQuery !== '' &&
      searchQuery.includes('fe') &&
      searchQuery.includes('ae') &&
      searchQuery.includes('handles')
    ) {
      let searchObject = JSON.parse('{"' + searchQuery.replace(/&/g, '","').replace(/=/g, '":"') + '"}', function (key, value) { return key === "" ? value : decodeURIComponent(value) });

      delete Object.assign(searchObject, { ['parentsName']: searchObject['pn'] })['pn'];
      delete Object.assign(searchObject, { ['kidsName']: searchObject['fe'] })['fe'];
      delete Object.assign(searchObject, { ['age']: searchObject['ae'] })['ae'];
      delete Object.assign(searchObject, { ['gender']: searchObject['ge'] })['ge'];
      delete Object.assign(searchObject, { ['quizID']: searchObject['quizID'] })['quizID'];

      const numberedHandles = searchObject.handles.split(',');
      const numberedPriorities = searchObject.priority.split(',');
      console.log(numberedPriorities);
      const numberedDiets = searchObject.selectedDiets.split(',');
      let urlHandles = [];
      let allHandles = [];
      let urlPriorities = [];
      let urlDiets = [];

      numberedHandles.forEach(handle => {
        switch (handle) {
          case '1':
            urlHandles.push('silica-kids');
            allHandles.push('silica-kids');
            break;
          case '2': 
            if (searchObject["age"] < 9) {
              urlHandles.push('k2-vital-delta-kids-4');
              allHandles.push('k2-vital-delta-kids-4');
            } else {
              urlHandles.push('k2-vital-delta-kids-9');
              allHandles.push('k2-vital-delta-kids-9');
            }
            break;
          case '3':
            urlHandles.push('lactospore-probiotic-kids');
            allHandles.push('lactospore-probiotic-kids');
            break;
          case '4':
            urlHandles.push('maca-powder-kids');
            allHandles.push('maca-powder-kids');
            break;
          case '5':
            urlHandles.push('ginger-kids');
            allHandles.push('ginger-kids');
            break;
          case '6':
            urlHandles.push('beetroot-kids');
            allHandles.push('beetroot-kids');
            break;
          case '7':
            urlHandles.push('lycopene-kids');
            allHandles.push('lycopene-kids');
            break;
          case '8':
            urlHandles.push('beta-glucan-kids');
            allHandles.push('beta-glucan-kids');
            break;
          case '9':
            urlHandles.push('tart-cherry-kids');
            allHandles.push('tart-cherry-kids');
            break;
          case '10':
            urlHandles.push('selenium-kids');
            allHandles.push('selenium-kids');
            break;
          case '11':
            urlHandles.push('hydrocurc-pepperine-kids');
            allHandles.push('hydrocurc-pepperine-kids');
            break;
          case '12':
            urlHandles.push('scutellup-kids');
            allHandles.push('scutellup-kids');
            break;
          default:
            break;
        }
      });
      
      const kidsCoreBlends4 = ['vitamin-c-kids-4', 'coq10-b12-kids-4', 'folic-acid-vitamin-d3-kids-4', 'iron-zinc-kids-4', 'vitamin-a-vitamin-e-kids-4'];
      const kidsCoreBlendSplit4 = ['vitamin-c-kids-4', 'coq10-kids-4', 'b12-kids-4', 'folic-acid-kids-4', 'vitamin-d3-kids-4', 'iron-kids-4', 'zinc-kids-4', 'vitamin-a-kids-4', 'vitamin-e-kids-4'];
      const kidsCoreBlends9 = ['vitamin-c-kids-9', 'coq10-b12-kids-9', 'folic-acid-vitamin-d3-kids-9', 'iron-zinc-kids-9', 'vitamin-a-vitamin-e-kids-9'];
      const kidsCoreBlendSplit9 = ['vitamin-c-kids-9', 'coq10-kids-9', 'b12-kids-9', 'folic-acid-kids-9', 'vitamin-d3-kids-9', 'iron-kids-9', 'zinc-kids-9', 'vitamin-a-kids-9', 'vitamin-e-kids-9'];
      
      if(searchObject["age"] < 9){
        urlHandles = urlHandles.concat(kidsCoreBlends4);
        allHandles = allHandles.concat(kidsCoreBlendSplit4);
      } else {
        urlHandles = urlHandles.concat(kidsCoreBlends9);
        allHandles = allHandles.concat(kidsCoreBlendSplit9);
      }

      numberedPriorities.forEach(priority => {
        console.log(priority);
        switch (priority) {
          case '1':
            urlPriorities.push('More energy');
            break;
          case '2':
            urlPriorities.push('Better immunity');
            break;
          case '3':
            urlPriorities.push('Better focus & memory');
            break;
          case '4':
            urlPriorities.push('Improve skin, hair, nails & acne');
            break;
          case '5':
            urlPriorities.push('Protect eyes from screen exposure');
            break;
          case '6':
            urlPriorities.push('Better stress management & mental wellbeing');
            break;
          case '7':
            urlPriorities.push('Improve gut health');
            break;
          case '8':
            urlPriorities.push('Get more fruit & veg');
            break;
          case '9':
            urlPriorities.push('Maintain active lifestyle');
            break;
          default:
            break;
        }
      });

      numberedDiets.forEach(diet => {
        switch (diet) {
          case '1':
            urlDiets.push('Vegetarian');
            break;
          case '2':
            urlDiets.push('Vegan');
            break;
          case '3':
            urlDiets.push('Pescatarian');
            break;
          case '4':
            urlDiets.push('Dairy free');
            break;
          case '5':
            urlDiets.push('Gluten free');
            break;
          case '6':
            urlDiets.push('Nut free');
            break;
          case '7':
            urlDiets.push('Reducetarian');
            break;
          default:
            break;
        }
      });

      searchObject["handles"] = urlHandles;
      searchObject["allHandles"] = allHandles;
      searchObject["priority"] = urlPriorities;
      searchObject["selectedDiets"] = urlDiets.join(', ');

      kidsQuizResults = searchObject;
      window.localStorage.setItem('kids-quiz-results', JSON.stringify(searchObject));
      console.log(JSON.stringify(searchObject));
    } else {
      kidsQuizResults = JSON.parse(window.localStorage.getItem("kids-quiz-results"));
    }

    return (
      <Results kidsQuizResults={kidsQuizResults} />
    )
  }
}

const rootElement = document.getElementById("quiz-results-root");
ReactDOM.render(<App />, rootElement);
